import { Header, PageTitle } from '@components';
import { BottomBarProvider } from '@contexts/BottomBarContext';
import { PageTitleProvider } from '@contexts/PageTitleContext';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './UnauthentifiedLayout.scss';
import { pageTitles } from '@components/PageTitle/pageTitles';

export const UnauthentifiedLayout: React.FC = () => {
    const location = useLocation();

    //mieux que le hide avec paths
    const pageTitle = pageTitles[location.pathname];
    const shouldHideHeader = pageTitle?.hideHeader || false;

    return (
        <PageTitleProvider>
            <BottomBarProvider>
                <div className="unauthentified-layout">
                    {!shouldHideHeader && (
                        <Header>
                            <PageTitle />
                        </Header>
                    )}
                    <div className="rendered-page">
                        <Outlet />
                    </div>
                </div>
            </BottomBarProvider>
        </PageTitleProvider>
    );
};

export default UnauthentifiedLayout;
